import { motion } from "framer-motion";
import heroBg from "@/assets/hero-bg.webp";

const HeroSection = () => {
  return (
    <section className="hero-section relative h-[90vh] max-h-[760px] flex flex-col justify-end overflow-hidden">
      <h1 className="sr-only">Stillwater Therapy — Psychotherapy in Dallas, TX with Ashley Bass, LMFT</h1>
      <img
        src={heroBg}
        alt=""
        aria-hidden="true"
        fetchPriority="high"
        decoding="async"
        className="hero-background absolute inset-0 w-full h-full object-cover"
      />

      <div className="hero-overlay absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent" />
      <div className="hero-content absolute z-10 w-full top-[10em] py-10 px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="hero-inner flex flex-col items-center text-center max-w-2xl mx-auto"
        >
          <blockquote className="hero-quote relative mb-8">
            <span
              className="absolute -top-6 -left-4 text-6xl md:text-7xl font-serif leading-none select-none"
              style={{ color: "hsl(var(--foreground) / .2)" }}
            >
              {"\u201C"}
            </span>
            <p
              className="text-xl md:text-2xl lg:text-3xl font-heading italic text-foreground leading-relaxed"
              style={{ textShadow: "0 1px 6px #ffffff61" }}
            >
              Not everything that is faced can be changed, but nothing can be changed until it is faced.
            </p>
            <span
              className="absolute -bottom-8 -right-4 text-6xl md:text-7xl font-serif leading-none select-none"
              style={{ color: "hsl(var(--foreground) / .2)" }}
            >
              {"\u201D"}
            </span>
          </blockquote>
          <cite className="hero-attribution font-body text-sm text-muted-foreground not-italic tracking-wide uppercase mb-6">
            — James Baldwin
          </cite>
          <a
            href="https://ashley-bass.clientsecure.me/request/service"
            target="_blank"
            rel="noopener noreferrer"
            className="hero-cta inline-block px-8 py-3 font-body tracking-wider text-sm uppercase hover:opacity-90 transition-opacity rounded-md text-primary border-primary border-2 font-bold bg-gray-50/0"
          >
            Book a Consultation
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default HeroSection;
